<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';


export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            id: '',
            pay: {},
            load: false,
        }
    },
    methods: {
        closedModal() {
            this.$modal.hide('tablePays');
        },
        getServiceAmounts(column, in_group, services = [], sumArray = []) {
            let sum = 0;         

            if (services) {
                services.forEach((element) => {
                    if (in_group == 3) {
                        if (element.negative == 1) {
                            sum -= element[column];
                        } else {
                            sum += element[column];
                        }
                    }else if (element.group_bill == in_group) {
                        if (element.negative == 1) {
                            sum -= element[column];
                        } else {
                            sum += element[column];
                        }
                    }
                });
            }

            if (sumArray) {
                sumArray.forEach((element) => {
                    sum += parseFloat(element);
                });
            }

            return sum;

        },
        async formDataPaysFast(pay) {
            try {
                this.$swal({
                    title: 'Se realizo el pago',
                    text: '¿ Se aprobara el pago ?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Pagado',
                    cancelButtonText: 'Cancelar'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        let form = {
                            tenant_id: pay.id,
                            bank_id: pay.bank_account_id,
                            date: this.moment().format("YYYY-MM-DD"),
                            amount: pay.amount,
                            type_payment_id: pay.type_payment_id,
                            description: pay.description
                        };
                        let _endpoint = '/tenant_pay';

                        let { data } = await request.postMedia(_endpoint, form)
                        if (data) {
                            this.successNotification(data.message);
                            this.list();
                        }
                    }
                });
            } catch (error) {
                this.$modal.hide('LoadPay');
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },

        async list() {
            this.load = true;
            let service = request;
            let _endpoint = `/tenant/${this.id}`;
            try {
                let { data } = await service.get(_endpoint)
                if (data) {
                    this.pay = data;
                    this.load = false;
                }
            } catch (error) {
                console.log(error);
                this.load = false;
            }
        },
        getPays(checks) {
            let result = 0;
            console.log('checks');
            console.log(checks);

            if (checks) {
                checks.forEach((check) => {
                    if(check.service){
                        if(check.service.name != "Deposito de garantía"){
                            check.pay.forEach((pay) => {                        
                                result += parseFloat(pay.amount);
                            });
                        }
                    }else{
                        check.pay.forEach((pay) => {                        
                            result += parseFloat(pay.amount);
                        });
                    }
                });
            }
            return result;
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    created() {
        Event.$on("event-show-tablePays", (pay) => {
            this.id = pay.id;
            this.list();
            this.$modal.show('tablePays');
        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    }
}
</script>
<template>
    <modal v-bind:click-to-close="false" name="tablePays" :width="'80%'" :scrollable="true" :maxHeight="300"
        :height="'auto'">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="saveBuildings" method="post" enctype="multipart/form-data">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Información pago de arrendatario</h5>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-4">
                        <h5><span class="badge badge-success">Al corriente</span></h5>
                    </div>
                    <div class="col-12 table-responsive" v-if="pay">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th rowspan="2" class="thead">ID</th>
                                    <th rowspan="2" class="thead">Fecha</th>
                                    <th colspan="7" class="text-center">Renta</th>
                                    <th colspan="7" class="text-center">Servicios y extras</th>
                                    <th rowspan="2" class="thead">A pagar</th>
                                    <th rowspan="2" class="thead">Pagado</th>
                                    <th rowspan="2" class="thead">Por pagar</th>
                                    <!-- <th></th> -->
                                </tr>

                                <tr>
                                    <!-- Renta  -->
                                    <th>
                                        Subtotal
                                    </th>
                                    <th>
                                        IVA
                                    </th>
                                    <th>
                                        IEPS
                                    </th>
                                    <th>
                                        ISR RET
                                    </th>
                                    <th>
                                        IVA RET
                                    </th>
                                    <th>
                                        Descuento
                                    </th>
                                    <th>
                                        Total
                                    </th>
                                    <!-- Servicios  -->
                                    <th>
                                        Subtotal
                                    </th>
                                    <th>
                                        IVA
                                    </th>
                                    <th>
                                        IEPS
                                    </th>
                                    <th>
                                        ISR RET
                                    </th>
                                    <th>
                                        IVA RET
                                    </th>
                                    <th>
                                        Descuento
                                    </th>
                                    <th>
                                        Total
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-if="load">
                                <tr>
                                    <td align="center" colspan="22">
                                        <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                        <h5>Cargando</h5>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr :class="pay.payment == 1 ? 'table-success' : ''">
                                    <td>
                                        {{ pay.id }}
                                    </td>
                                    <td> {{ pay.star_date | toDateTime }}</td>
                                    <td>
                                        {{
                                            (pay.subtotal * 1)  + (getServiceAmounts('subtotal', 1, pay.all_services) * 1) |
                                            toCurrency
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            (pay.iva * 1) + (getServiceAmounts('iva', 1, pay.all_services) * 1) | toCurrency
                                        }}
                                    </td>
                                    <td> 
                                        {{ 
                                            (pay.ieps * 1) + (getServiceAmounts('ieps', 1, pay.all_services) * 1) | toCurrency
                                        }}
                                    </td>
                                    <td> 
                                        {{ 
                                            (pay.isr_ret * 1) + (getServiceAmounts('isr_ret', 1, pay.all_services) * 1) | toCurrency
                                        }}
                                    </td>
                                    <td> 
                                        {{ 
                                            (pay.iva_ret * 1) + (getServiceAmounts('iva_ret', 1, pay.all_services) * 1) | toCurrency
                                        }}
                                    </td>
                                    <td> 
                                        {{ 
                                            (pay.discount * 1) + (getServiceAmounts('discount', 1, pay.all_services) * 1) | toCurrency
                                        }}
                                    </td>
                                    <td> {{ 
                                            (pay.amount * 1) + (getServiceAmounts('amount', 1, pay.all_services) * 1) | toCurrency
                                        }}
                                    </td>

                                    <td> 
                                        {{ getServiceAmounts('subtotal', 0, pay.all_services) | toCurrency }}
                                    </td>
                                    <td> 
                                        {{ getServiceAmounts('iva', 0, pay.all_services) | toCurrency }}
                                    </td>
                                    <td> 
                                        {{ getServiceAmounts('ieps', 0, pay.all_services) | toCurrency }}
                                    </td>
                                    <td> 
                                        {{ getServiceAmounts('isr_ret', 0, pay.all_services) | toCurrency }}
                                    </td>
                                    <td> 
                                        {{ getServiceAmounts('iva_ret', 0, pay.all_services) | toCurrency }}
                                    </td>
                                    <td> 
                                        {{ getServiceAmounts('discount', 0, pay.all_services) | toCurrency }}
                                    </td>
                                    <td> 
                                        {{ getServiceAmounts('amount', 0, pay.all_services) | toCurrency }}
                                    </td>
                                    <td>                                     
                                        {{ getServiceAmounts('amount', 3, pay.all_services, [pay.amount]) | toCurrency }}
                                    </td>
                                    <td> 
                                        <span v-if="pay.payment == 1">
                                            {{ getServiceAmounts('amount', 3, pay.all_services, [pay.amount]) | toCurrency }}
                                        </span>
                                        <span v-else>
                                            {{ getPays(pay.checks) | toCurrency }}
                                        </span>
                                    </td>
                                    <td> 
                                        <span v-if="pay.payment == 1">
                                            $ 0.00
                                        </span>
                                        <span v-else>
                                            {{ getServiceAmounts('amount', 3, pay.all_services, [pay.amount]) - getPays(pay.checks) | toCurrency }}
                                        </span>                                        
                                    </td>                                  
                                </tr>
                                <tr :class="pay_child.payment == 1 ? 'table-success' : ''" v-for="(pay_child, index) in pay.tenants" :key="index">
                                    <td> 
                                        {{ pay_child.id }}
                                    </td>
                                    <td> {{ pay_child.star_date | toDateTime }}</td>
                                    <td>
                                        {{
                                            (pay_child.subtotal * 1) + (getServiceAmounts('subtotal', 1, pay_child.all_services) * 1) |
                                            toCurrency
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            (pay_child.iva * 1) + (getServiceAmounts('iva', 1, pay_child.all_services) * 1) | toCurrency
                                        }}
                                    </td>
                                    <td> 
                                        {{ 
                                            (pay_child.ieps * 1) + (getServiceAmounts('ieps', 1, pay_child.all_services) * 1) | toCurrency
                                        }}
                                    </td>
                                    <td> 
                                        {{ 
                                            (pay_child.isr_ret * 1) + (getServiceAmounts('isr_ret', 1, pay_child.all_services) * 1) | toCurrency
                                        }}
                                    </td>
                                    <td> 
                                        {{ 
                                            (pay_child.iva_ret * 1) + (getServiceAmounts('iva_ret', 1, pay_child.all_services) * 1) | toCurrency
                                        }}
                                    </td>
                                    <td> 
                                        {{ 
                                            (pay_child.discount * 1) + (getServiceAmounts('discount', 1, pay_child.all_services) * 1) | toCurrency
                                        }}
                                    </td>
                                    <td> {{ 
                                            (pay_child.amount * 1) + (getServiceAmounts('amount', 1, pay_child.all_services) * 1) | toCurrency
                                        }}
                                    </td>

                                    <td> 
                                        {{ getServiceAmounts('subtotal', 0, pay_child.all_services) | toCurrency }}
                                    </td>
                                    <td> 
                                        {{ getServiceAmounts('iva', 0, pay_child.all_services) | toCurrency }}
                                    </td>
                                    <td> 
                                        {{ getServiceAmounts('ieps', 0, pay_child.all_services) | toCurrency }}
                                    </td>
                                    <td> 
                                        {{ getServiceAmounts('isr_ret', 0, pay_child.all_services) | toCurrency }}
                                    </td>
                                    <td> 
                                        {{ getServiceAmounts('iva_ret', 0, pay_child.all_services) | toCurrency }}
                                    </td>
                                    <td> 
                                        {{ getServiceAmounts('discount', 0, pay_child.all_services) | toCurrency }}
                                    </td>
                                    <td> 
                                        {{ getServiceAmounts('amount', 0, pay_child.all_services) | toCurrency }}
                                    </td>
                                    <td>                                     
                                        {{ getServiceAmounts('amount', 3, pay_child.all_services, [pay_child.amount]) | toCurrency }}
                                    </td>                                    
                                    <td> 
                                        <span v-if="pay_child.payment == 1">
                                            {{ getServiceAmounts('amount', 3, pay_child.all_services, [pay_child.amount]) | toCurrency }}
                                        </span>
                                        <span v-else>
                                            {{ getPays(pay_child.checks) | toCurrency }}
                                        </span>                                        
                                    </td>
                                    <td> 
                                        <span v-if="pay_child.payment == 1">
                                            $ 0.00
                                        </span>
                                        <span v-else>
                                            {{ getServiceAmounts('amount', 3, pay_child.all_services, [pay.amount]) -
                                            getPays(pay_child.checks) | toCurrency }}
                                        </span>                                        
                                        
                                    </td>

                                  
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>

<style>
table {
    border-collapse: collapse;
    width: 100%;
}

.thead {
    border: 1px solid #ddd;
    vertical-align: middle;
    text-align: center;
    /* Centra horizontalmente */
    vertical-align: middle;
    /* Centra verticalmente */
    padding: 8px;
}

th {
    background-color: #f2f2f2;
}
</style>